"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Stardate = exports.setIsReactNative = exports.setUserId = exports.setEnvironment = exports.StardateLogKind = exports.StardateSourceEnum = void 0;
const axios_1 = __importDefault(require("axios"));
const ejson_1 = __importDefault(require("ejson"));
var StardateSourceEnum;
(function (StardateSourceEnum) {
    StardateSourceEnum["frontendWeb"] = "frontend";
    StardateSourceEnum["frontendNative"] = "frontendNative";
    StardateSourceEnum["frontendPackage"] = "frontendPackage";
    StardateSourceEnum["backend"] = "backend";
    StardateSourceEnum["backendPackage"] = "backendPackage";
    StardateSourceEnum["universalPackage"] = "universalPackage";
})(StardateSourceEnum = exports.StardateSourceEnum || (exports.StardateSourceEnum = {}));
var StardateLogKind;
(function (StardateLogKind) {
    StardateLogKind["trace"] = "trace";
    StardateLogKind["info"] = "info";
    StardateLogKind["latency"] = "latency";
    StardateLogKind["warning"] = "warning";
    StardateLogKind["error"] = "error";
})(StardateLogKind = exports.StardateLogKind || (exports.StardateLogKind = {}));
function checkForWindowFetch() {
    try {
        return typeof window != null && typeof window.fetch === 'function';
    }
    catch (e) {
        return false;
    }
}
const hasFetch = checkForWindowFetch();
const sessionId = Date.now().toString() + Math.random().toString().slice(2) + Math.random().toString().slice(2);
let environment = null;
function setEnvironment(env) {
    environment = env;
}
exports.setEnvironment = setEnvironment;
let userId = null;
function setUserId(u) {
    userId = u;
}
exports.setUserId = setUserId;
let isReactNative = false;
function setIsReactNative(value) {
    isReactNative = value;
}
exports.setIsReactNative = setIsReactNative;
function serializeError(error) {
    return {
        name: error.name,
        message: error.message,
        stack: error.stack,
        code: error.code,
        cause: error.cause,
        description: error.description,
        source: error.source,
        str: error.toString(),
    };
}
class Stardate {
    source;
    platform;
    module;
    tenant;
    userId;
    constructor(source, platform, module, tenant, userId) {
        this.source = source;
        this.platform = platform;
        this.module = module;
        this.tenant = tenant;
        this.userId = userId;
    }
    withUserId = (userId) => {
        this.userId = userId;
        return this;
    };
    logInternal = async (value, options) => {
        const item = {
            value,
            sessionId,
            date: new Date(),
            source: this.source,
            platform: this.platform,
            module: this.module,
            tenant: this.tenant,
            environment,
            userId: options?.actor ?? userId ?? this.userId ?? null,
        };
        if (item.value.kind === StardateLogKind.error) {
            item.value.error = serializeError(item.value.error);
        }
        const body = ejson_1.default.stringify(item);
        if (!isReactNative) {
            switch (item.value.kind) {
                case StardateLogKind.trace:
                    console.debug(`[${this.module}]` + new Date().toString() + ': ' + item.value.message);
                    break;
                case StardateLogKind.info:
                    console.info(`[${this.module}]` + new Date().toString() + ': ' + item.value.message, item.value.data);
                    break;
                case StardateLogKind.latency:
                    console.debug(`[${this.module}/${item.value.method}]` + new Date().toString() + ' <-> ' + item.value.duration);
                    break;
                case StardateLogKind.warning:
                    console.warn(`[${this.module}]` + new Date().toString() + ': ' + item.value.message, item.value.data);
                    break;
                case StardateLogKind.error:
                    console.error(`[${this.module}]` + new Date().toString() + ': ' + item.value.message, item.value.data, item.value.error);
                    break;
            }
        }
        try {
            if (hasFetch) {
                await window.fetch("https://stardate.hiyllo.cloud/log/in", {
                    method: 'POST',
                    body,
                });
            }
            else {
                await axios_1.default.post("https://stardate.hiyllo.cloud/log/in", body);
            }
        }
        catch (e) {
            console.error('Failed to log to Stardate', e);
        }
    };
    log(value, options) {
        void this.logInternal(value, options);
    }
}
exports.Stardate = Stardate;
